import React from "react";
import { Helmet } from "react-helmet";
import { getAssetsPublicPath } from "../../utils/utils";

function AppJS() {
  return (
    <>
      <Helmet>
      
      <script
        // async={false}
        // type="text/javascript"
        type="text/javascript"
        src={`${getAssetsPublicPath("app/js/combined.js")}`}
      ></script>

        {/* <script
          src="https://code.jquery.com/jquery-3.5.1.min.js"
          integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0="
          crossorigin="anonymous"
        ></script>
        <script
          src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js"
          integrity="sha384-UO2eT0CpHqdSJQ6hJty5KVphtPhzWj9WO1clHTMGa3JDZwrnQq4sF86dIHNDz0W1"
          crossorigin="anonymous"
        ></script>
        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>
        <script src="https://code.iconify.design/2/2.1.2/iconify.min.js"></script> */}
      </Helmet>
    </>
  );
}

export default AppJS;
